import React from 'react'
import { Button, Tooltip } from 'antd';
import { CopyTwoTone } from '@ant-design/icons';
import {CopyToClipboard} from 'react-copy-to-clipboard';

export function LarpTOMCopyToClipboard({text}) {
    return (

            <Tooltip title="Copy to clipboard">
                <CopyToClipboard text={text} >
                    <Button type="text" 
                        icon={<CopyTwoTone />} >
                    </Button>
                </CopyToClipboard>
            </Tooltip>

    )
}